import React, { useState, useEffect } from 'react';
import './ProgressiveImage.css';

const ProgressiveImage = ({ src, alt, className, placeholderSrc }) => {
  const [imgSrc, setImgSrc] = useState(placeholderSrc || null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Create a new image to preload
    const img = new Image();
    img.src = src;
    
    img.onload = () => {
      setImgSrc(src);
      setIsLoading(false);
    };

    img.onerror = () => {
      setIsLoading(false);
    };
  }, [src]);

  return (
    <div className={`progressive-image-container ${className || ''}`}>
      <img
        src={imgSrc || src}
        alt={alt}
        className={`progressive-image ${isLoading ? 'loading' : 'loaded'}`}
        loading="lazy"
      />
      {isLoading && (
        <div className="progressive-image-loader">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
};

export default ProgressiveImage;

